var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "border border-transparent transition-colors duration-200",
      class: { "border-red rounded-sm": _vm.$v.value.$anyError },
      attrs: { "data-testid": "wall-form" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center justify-between bg-cream px-2 sm:px-5 py-3 rounded-t-sm",
        },
        [
          _c("h3", { staticClass: "font-semibold" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "link",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("delete", _vm.index)
                },
              },
            },
            [
              _c("span", { staticClass: "sr-only" }, [_vm._v("Remove")]),
              _vm._v(" "),
              _c("div", { staticClass: "w-3 h-3" }, [_c("IconCrossSmall")], 1),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "px-2 sm:px-5 py-5 rounded-b-sm bg-cream bg-opacity-50 grid sm:grid-cols-2 gap-6 sm:gap-8",
        },
        [
          _c(
            "div",
            { staticClass: "space-y-2" },
            [
              _c("DimensionInput", {
                attrs: {
                  id: `wall-length-${_vm.index}`,
                  label: "Length",
                  value: _vm.value.length,
                  error: _vm.$v.value.length.$error,
                },
                on: {
                  input: (event) => _vm.emitInput(event.target.value, "length"),
                },
              }),
              _vm._v(" "),
              _c("DimensionInput", {
                attrs: {
                  id: `wall-height-${_vm.index}`,
                  label: "Height",
                  value: _vm.value.height,
                  error: _vm.$v.value.height.$error,
                },
                on: {
                  input: (event) => _vm.emitInput(event.target.value, "height"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "space-y-2" },
            [
              _c("NumericSelect", {
                attrs: {
                  id: `doors-${_vm.index}`,
                  label: "Doors",
                  value: _vm.value.doors,
                  max: 4,
                },
                on: {
                  input: (event) => _vm.emitInput(event.target.value, "doors"),
                },
              }),
              _vm._v(" "),
              _c("NumericSelect", {
                attrs: {
                  id: `windows-${_vm.index}`,
                  label: "Windows",
                  value: _vm.value.windows,
                  max: 4,
                },
                on: {
                  input: (event) =>
                    _vm.emitInput(event.target.value, "windows"),
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }